module.exports = __webpack_public_path__ + "./img-chels_11ef54d3bdffb2b8067d5b3b451acd05.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2017/img-chels.png
// module id = 445
// module chunks = 0